module.exports = __webpack_public_path__ + "static/media/golden-bullet.5a63ffbd.svg";